module.exports = __webpack_public_path__ + "img/5.a0f959e3.jpg";